import { Link } from "react-router-dom";

const TableApproved = ({ details }) => {
  return (
    <>
      <table
        className="approved assigned"
        style={{ marginTop: "5px", marginBottom: "15px" }}
      >
        <thead>
          <tr>
            <th className="center" style={{ width: "17.5%" }}>
              Room ID
            </th>
            <th className="center" style={{ width: "17.5%" }}>
              Confirmation #
            </th>
            <th className="left" style={{ width: "65%" }}>
              Notes
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="center">{details.roomId}</td>
            <td className="center">{details.confirmation}</td>
            <td className="left">{details.notes}</td>
          </tr>
          <tr>
            <td className="left" colSpan="3">
              {details.lastUpdated}
            </td>
          </tr>
        </tbody>
      </table>

      <Link className="btn btn-default" to="/admin/hotel">
        <i className="fa fa-angle-left" /> &nbsp;Back
      </Link>
    </>
  );
};

export default TableApproved;
